import React, { useState, useEffect } from "react";

export default function PaginatedSortableControls({
  currentPage,
  hasNext,
  rowsPerPage,
  rowsPerPageOptions,
  sortConfig,
  sortOptions,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
}) {

  const [pageInput, setPageInput] = useState(currentPage);

  useEffect(() => {
    setPageInput(currentPage);
  }, [currentPage]);

  const movePage = (page) => {
    const p = Math.max(1, Number(page) || 1);
    onPageChange(p);
  };

  const handlePageInputKey = (e) => {
    if (e.key === "Enter") {
      movePage(pageInput);
    }
  };

  return (
    <div className="card-inner py-2">
      <div className="row align-items-center">

        {/* pagination */}
        <div className="col-12 col-md-5">
          <ul className="pagination mb-0">

            {/* first */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => movePage(1)}
                disabled={currentPage === 1}
              >
                처음
              </button>
            </li>

            {/* prev */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => movePage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                이전
              </button>
            </li>

            {/* page input */}
            <li className="page-item">
              <input
                type="number"
                className="form-control text-center"
                style={{ width: 80 }}
                value={pageInput}
                min={1}
                onChange={(e) => setPageInput(e.target.value)}
                onKeyDown={handlePageInputKey}
              />
            </li>

            {/* next */}
            <li className={`page-item ${!hasNext ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => movePage(currentPage + 1)}
                disabled={!hasNext}
              >
                다음
              </button>
            </li>

          </ul>
        </div>

        {/* rows per page */}
        <div className="col-6 col-md-3">
          <select
            className="form-select"
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          >
            {rowsPerPageOptions.map((size) => (
              <option key={size} value={size}>
                리스트 - {size}
              </option>
            ))}
          </select>
        </div>

        {/* sort */}
        <div className="col-6 col-md-4">
          <select
            className="form-select"
            value={`${sortConfig.field}:${sortConfig.order}`}
            onChange={(e) => {
              const [field, order] = e.target.value.split(":");
              onSortChange(field, order);
            }}
          >
            {sortOptions.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>

      </div>
    </div>
  );
}